import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"
import { ensureArray } from "lib/ensure-array"

export const summariseAssetTasks = api(({ summarise, filters, regimeId, group, search, sort }) =>
    query(
        gql`
            query SummariseAssetTasks(
                $regimeId: String!
                $group: String
                $search: String
                $sort: [String]
                $summarise: [String!]!
                $filters: [JSONObject]
            ) {
                regimeAssetTaskSummary(
                    regimeId: $regimeId
                    group: $group
                    sort: $sort
                    search: $search
                    filters: $filters
                ) {
                    id
                    summarise(by: $summarise) {
                        summary(take: 10000) {
                            key
                            value
                            count
                            minutes
                        }
                    }
                }
            }
        `,
        {
            summarise: ensureArray(summarise),
            regimeId,
            group,
            sort,
            search,
            filters,
        },
        { returns: "regimeAssetTaskSummary.summarise.summary" }
    )
)
